<template>
  <div>
    <!--    <div v-if="isShowPage">-->
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline"  @keydown.native.enter="handleSearchBtn">
        <div id="searchBox">
          <el-form-item label="" prop="xhname">
          <el-select
            ref="selectRef"
            @change="handleChange"
            class="model-select"
            v-model="keyword"
            filterable
            remote
            popper-append-to-body
            reserve-keyword
            :automatic-dropdown="true"
            :default-first-option="true"
            placeholder="请输入轴承型号"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table search-table">
      <el-table border fit highlight-current-row class="customer-table" :data="list">
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="订单号" prop="orderid"></el-table-column>
        <el-table-column label="型号" prop="xhname"></el-table-column>
        <el-table-column label="品牌" prop="source"></el-table-column>
        <el-table-column label="数量" prop="num"></el-table-column>
        <el-table-column label="单价" prop="price"></el-table-column>
        <el-table-column label="货期" prop="sendtime"></el-table-column>
        <el-table-column label="报价公司" prop="company"></el-table-column>
        <el-table-column label="负责人" prop="rname"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row,$index}">
            <el-button type="primary" size="mini"
                       :disabled="row.state === 'T' || disabledIndexes.includes(row.id)"
                       @click="addToDrawer(row,$index)">添加
            </el-button>
<!--            <el-popconfirm-->
<!--              iconColor="red"-->
<!--              @confirm="handleDelete(scope.row,scope.$index)"-->
<!--              title="确认删除此条数据吗？"-->
<!--            >-->
<!--              <el-button slot="reference" type="danger" size="mini" class="el-icon-delete">删除</el-button>-->
<!--            </el-popconfirm>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
    <!--      已添加数据弹窗-->
    <el-drawer
      title="生成合同"
      :visible.sync="drawerVisible"
      :size="getIsMobile?'100%':'30%'">
      <el-table :data="addedData" border class="drawer-table">
        <el-table-column prop="xhname" label="型号" />
        <el-table-column prop="source" label="品牌" />
      </el-table>
      <div class="dialog-footer">
        <el-button @click="handleContract(addedData)" style="margin-right: 5px" type="primary">生成合同</el-button>
        <el-button @click="handleClear" style="margin-right: 5px" type="danger">清空</el-button>
      </div>
    </el-drawer>
    <el-button type="primary" plain class="add-btn" @click="handleAddXname">已添加（{{ addedData.length || addedNum }}）
    </el-button>
    <CreateContract :dialog="contractDialog" :data="contractData" @close="contractClose" :companyId="companyId"/>
  </div>
  <!--    <el-empty description="暂无权限查看数据" v-else class="customer-category_empty" />-->
  <!--  </div>-->
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'
import useRootSetting from '@/hooks/useRootSetting'
import CreateContract from './detail.vue'

export default defineComponent({
  components: { CreateContract, PageWrapper },
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { getIsMobile } = useRootSetting()
    const instance = getCurrentInstance()
    const { proxy } = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showAll = ref(false)
    const isShowPage = ref(false)
    const drawerVisible = ref(false) //控制已添加数据弹窗
    const addedData = ref([])//已添加的数据
    const addedNum = ref(0)//已添加条数
    const disabledIndexes = ref([])//添加完按钮禁用
    const contractDialog = ref(false)//已添加里生成报价单的弹窗
    const contractData = ref([])
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const list = ref([])

    const searchFormRef = ref(null)
    const searchForm = reactive({
      xhname: ''
    })


    const companyId = ref('')

    onMounted(()=>{
      companyId.value = proxy.$route.params.id
      getQuotation(companyId.value)
    })

    const getQuotation = (companyId) => {
      request({
        url: 'ci_create_contract_list.yy',
        method: 'post',
        params: selectPage,
        data: {
          id: companyId,
          username: username,
          ...searchForm
        }
      }).then(res => {
         if(res.code == 200) {
           list.value = res.data
           allNum.value = res.total
           if(!res.num) {
             addedNum.value = 0
           }else{
             addedNum.value = res.num
           }
         }
      })
    }

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getQuotation(companyId.value)
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getQuotation(companyId.value)
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getQuotation(companyId.value)
    }

    const handleResetBtn = () => {
      keyword.value  = ''
      searchForm.xhname = ''
      getQuotation(companyId.value)
    }

    //已添加列表展示
    const addToDrawer = (row, index) => {
      if (!disabledIndexes.value.includes(row.id)) {
        disabledIndexes.value.push(row.id);
      }
      drawerVisible.value = true
      request({
        url: 'ci_add_cart.yy',
        method: 'post',
        data: {
          id: row.id,
          username: username,
        }
      }).then(res => {
        const { code, msg } = res
        addedData.value = res.cartlist
        if (code == 200) {
          Message.success(msg)
        } else if (code == 300) {
          Message.warning(msg)
        } else if (code == 400) {
          Message.error(msg)
        }
      })
    }

    //已添加数据-全部删除
    const handleClear = () => {
      const ids = addedData.value.map(item => item.id)
      request({
        url: 'ci_delete_cart.yy',
        method: 'post',
        data: { id: ids, username: username }
      }).then(res => {
        if (res.code == 200) {
          Message.success(res.msg)
          addedData.value = []
          addedNum.value = 0
          getQuotation(companyId.value)
        }
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
      drawerVisible.value = false
    }

    //列表每行添加数据
    const handleAddXname = () => {
      drawerVisible.value = true
      request({
        url: 'ci_add_cart.yy',
        method: 'post',
        data: {
          username: username
        }
      }).then(res => {
        addedData.value = res.cartlist
      })
    }

    const handleContract = (data) => {
      drawerVisible.value = false
      contractDialog.value = true
      contractData.value = data
    }

    const contractClose = () => {
      contractDialog.value = false
    }

    const options = ref([])
    const loading = ref(false)
    const keyword = ref('')//搜索型号关键字
    //远程搜索型号方法
    const remoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const { data } = await request({
          url: 'ci_queryxh.yy',
          method: 'post',
          data: { xhname: query, id: companyId.value }
        })

        options.value = data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }

    //模糊下拉型号选中请求接口
    const handleChange = (xh) => {
      searchForm.xhname = xh
      getQuotation(companyId.value)
    }

    return {
      keyword,
      options,
      loading,
      companyId,
      contractData,
      contractDialog,
      addedData,
      drawerVisible,
      getIsMobile,
      isShowPage,
      username,
      searchFormRef,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      list,
      addedNum,
      disabledIndexes,
      handleChange,
      remoteMethod,
      contractClose,
      handleContract,
      handleAddXname,
      addToDrawer,
      closeSearch,
      handleResetBtn,
      handleSearchBtn,
      pageSizeChange,
      pageCurrentChange,
      handleClear
    }
  }
})
</script>
<style scoped lang="scss">
.el-icon-delete {
  margin-left: 10px;
}
.drawer-table {
  width: 95%;
  margin: auto;
}

.custom-btn {
  margin-left: 10px;
}

.dialog-footer {
  text-align: center;
  margin-top: 25px;
}

.add-btn {
  position: fixed;
  right: 0;
  top: 450px;
  z-index: 99
}
.model-select {
  margin-bottom: 10px
}

</style>

